module.exports = __webpack_public_path__ + "static/media/star-complete.cf78f259.svg";